import { useCallback, useState } from 'react';

import { IToastManagerProps } from '@features/ToastManager/model/types';

export const useComputeOffset = ({
    strategy,
    toastPosition,
}: Pick<IToastManagerProps, 'strategy' | 'toastPosition'>) => {
    const [offset, setOffset] = useState(24);

    const computeOffset = useCallback(() => {
        if (strategy !== 'fixed') return 24;

        if (toastPosition === 'left') {
            const isSidebarHidden = document.body.classList.contains('sidebar-hidden');
            if (isSidebarHidden) return 24;

            const sidebar = document.querySelector<HTMLElement>('.sidebar');
            const width = sidebar ? sidebar.offsetWidth : 0;
            return width + 24;
        }

        return 24;
    }, [toastPosition, strategy]);

    return {
        offset,
        setOffset,
        computeOffset,
    };
};
